import React, {Component, createRef} from "react";
import DataTable from './TableBase';
import {IconButton} from "@material-ui/core";
import {withRouter} from "react-router-dom";
import {apiCall} from "../../helpers/MainHelper";
import Swal from "sweetalert2";
import withPermissions from "../WithPermissions";
import ReactDOMServer from "react-dom/server";
import ReactLoading from "react-loading";

class StockItemsTable extends Component{

    constructor(props) {
        super(props);
        this.tableRef = createRef();
    }

    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };

    getStockBadge = (item) => {
        const totalStock = parseFloat(item.total_stock || 0);
        const minStock = parseFloat(item.min_stock_level || 0);
        const displayStock = Math.round(totalStock);

        if (totalStock === 0) {
            return <span className="badge badge-danger" style={{fontSize: '14px', padding: '6px 12px'}}>Stok Yok</span>;
        } else if (totalStock <= minStock) {
            return <span className="badge badge-warning" style={{fontSize: '14px', padding: '6px 12px'}}>{displayStock} adet</span>;
        } else {
            return <span className="badge badge-success" style={{fontSize: '14px', padding: '6px 12px'}}>{displayStock} adet</span>;
        }
    };

    handleDelete = async (itemId) => {
        const result = await Swal.fire({
            title: 'Silmek istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, sil!',
            cancelButtonText: 'Hayır, iptal et',
            preConfirm: async () => {
                const confirmButton = Swal.getConfirmButton();
                const originalButtonText = confirmButton.innerHTML;
                confirmButton.disabled = true;
                confirmButton.innerHTML = ReactDOMServer.renderToString(
                    <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
                );

                try {
                    await apiCall('business/stock/item/delete/'+itemId,'delete');
                    await this.triggerFetch();
                    return true;
                } catch (error) {
                    return false;
                } finally {
                    confirmButton.innerHTML = originalButtonText;
                    confirmButton.disabled = false;
                }
            }
        });

        if (result.isConfirmed) {
            if (result.value) {
                Swal.fire('Silindi!', 'Stok kalemi başarıyla silindi.', 'success');
            } else {
                Swal.fire('Hata!', 'Silme işlemi başarısız oldu.', 'error');
            }
        }
    }

    handleItemDetail = (itemId) => {
        this.props.history.push(`/stock/item-detail/${itemId}`);
    }

    render() {
        const {userPermissions} = this.props;
        const userHasViewPermission = userPermissions.includes('stock.view');
        const userHasDeletePermission = userPermissions.includes('stock.delete');

        const columns = [
            {
                name:'SKU',
                selector:row => row.sku,
                sortable:true,
                minWidth: '120px',
                maxWidth: '140px',
                cell: row => (
                    <div style={{fontWeight: '600', color: '#495057', fontFamily: 'monospace', padding: '12px 8px'}}>
                        {row.sku || '-'}
                    </div>
                )
            },
            {
                name:'Ürün Adı',
                selector:row => row.name,
                sortable:true,
                grow: 2,
                wrap: true,
                cell: row => (
                    <div style={{fontWeight: '500', color: '#212529', padding: '12px 8px'}}>
                        {row.name}
                    </div>
                )
            },
            {
                name:'Kategori',
                selector:row => row.category ? row.category.name : '-',
                sortable:true,
                grow: 1,
                wrap: true,
                style: {
                    padding: '12px 8px'
                }
            },
            {
                name:'Birim',
                selector:row => row.unit,
                sortable:true,
                minWidth: '90px',
                maxWidth: '110px',
                center: true,
                style: {
                    padding: '12px 8px'
                }
            },
            {
                name:'Birim Fiyat',
                selector:row => parseFloat(row.unit_price || 0),
                sortable:true,
                minWidth: '130px',
                maxWidth: '150px',
                right: true,
                cell: row => (
                    <div style={{fontWeight: '600', color: '#17a2b8', padding: '12px 8px'}}>
                        {parseFloat(row.unit_price || 0).toFixed(2)} ₺
                    </div>
                )
            },
            {
                name:'Toplam Stok',
                selector:row => row.total_stock || 0,
                sortable:true,
                cell: row => <div style={{padding: '8px'}}>{this.getStockBadge(row)}</div>,
                center: true,
                minWidth: '140px',
                maxWidth: '160px'
            },
            {
                name:'Min. Stok',
                selector:row => row.min_stock_level,
                sortable:true,
                minWidth: '100px',
                maxWidth: '120px',
                center: true,
                cell: row => (
                    <div style={{color: '#6c757d', fontWeight: '500', padding: '12px 8px'}}>
                        {Math.round(parseFloat(row.min_stock_level || 0))}
                    </div>
                )
            },
            {
                name:'Durum',
                selector:row => row.is_active ? 'Aktif' : 'Pasif',
                sortable:true,
                minWidth: '100px',
                maxWidth: '120px',
                center: true,
                cell: row => (
                    <span className={`badge badge-${row.is_active ? 'success' : 'secondary'}`} style={{
                        fontSize: '11px',
                        padding: '8px 12px',
                        fontWeight: '600',
                        minWidth: '65px',
                        display: 'inline-block'
                    }}>
                        {row.is_active ? 'Aktif' : 'Pasif'}
                    </span>
                )
            },
            {
                name: 'İşlem',
                button: true,
                minWidth: '140px',
                maxWidth: '160px',
                center: true,
                cell: row => (
                    <div style={{display: 'flex', gap: '6px', justifyContent: 'center', padding: '8px'}}>

                        {userHasDeletePermission && (
                            <IconButton 
                                className="btn btn-outline-danger"
                                onClick={() => this.handleDelete(row.id)}
                                style={{padding: '8px 14px'}}>
                                <i className="icon-trash" style={{fontSize: '16px'}}></i>
                            </IconButton>
                        )}
                    </div>
                ),
            },
        ];

        return (
            <DataTable
                ref={this.tableRef}
                columns={columns}
                onRowClicked={userHasViewPermission ? row => this.handleItemDetail(row.id) : undefined}
                dataEndpoint="business/stock/item/all"
            />
        );
    }
}

export default withPermissions(withRouter(StockItemsTable));
